import { useMutation } from '@tanstack/react-query';
import { POST, POST_LINE_MESSAGE_TEMPLATE_UPDATE } from '../../../services';
import { openAlert } from '../../../components/alert/useAlert';

export const useUpdateLineMessageTemplate = ({ onSuccessCallBack } = {}) =>
  useMutation({
    mutationFn: async (values) => {
      const response = await POST(POST_LINE_MESSAGE_TEMPLATE_UPDATE(), values);
      if (response?.success === false) throw new Error(response.message);
      return response?.result;
    },
    onSuccess: () => {
      openAlert({ model: 'message', type: 'success', message: 'แก้ไข template สำเร็จ' });
      onSuccessCallBack?.();
    },
  });
